import {Checkbox} from "components";
import {getName} from "helpers/string";
import CheckboxList from "mapx-components/Inputs/CheckboxList";
import React from "react";
import {TCity, TCountry, TRegion, TState} from "../types";
import CityItem from "./CityItem";

type StateItemProps = {
	state: TState;
	region: TRegion;
	country: TCountry;
	expanded: Record<number, boolean>;
	disabled: boolean;
	isSelected: boolean;
	isPartiallySelected: boolean;
	hasChildren: boolean;
	onToggle: () => void;
	onToggleExpand: () => void;
	isCitySelected: (
		cityId: number,
		stateId: number,
		regionId: number,
		countryId: number,
	) => boolean;
	onToggleCity: (city: TCity, state: TState, region: TRegion, country: TCountry) => void;
};

const StateItem: React.FC<StateItemProps> = ({
	state,
	region,
	country,
	expanded,
	disabled,
	isSelected,
	isPartiallySelected,
	hasChildren,
	onToggle,
	onToggleExpand,
	isCitySelected,
	onToggleCity,
}) => {
	return (
		<div key={state.id}>
			<CheckboxList.AccordionChildrenContent
				expanded={expanded[region.id]}
				key={state.id}
				childrenExpanded={expanded[state.id]}
				handleExpandClick={onToggleExpand}
				hasChildren={hasChildren}
				treeIndex={3}
				item={state}
			>
				<Checkbox
					borderColor="#0C5850"
					isChecked={isSelected}
					partiallySelected={isPartiallySelected}
					key={state.id}
					label={getName(state.name)}
					onChange={onToggle}
					value={getName(state.name)}
					disabled={disabled}
				/>
			</CheckboxList.AccordionChildrenContent>

			{/* Cities */}
			{state.cities?.map((city) => (
				<CityItem
					key={city.id}
					city={city}
					state={state}
					region={region}
					country={country}
					expanded={expanded[state.id]}
					disabled={disabled}
					treeIndex={4}
					isSelected={isCitySelected(city.id, state.id, region.id, country.id)}
					onToggle={() => onToggleCity(city, state, region, country)}
				/>
			))}
		</div>
	);
};

export default StateItem;
